package com.downdogapp.client.singleton

import com.downdogapp.*
import com.downdogapp.client.currentClockTime
import com.downdogapp.client.singleton.Network.commonRequestParams
import kotlinx.browser.localStorage
import kotlinx.browser.window
import org.w3c.fetch.RequestInit
import org.w3c.fetch.Response
import kotlin.collections.component1
import kotlin.collections.component2
import kotlin.collections.set
import kotlin.js.Promise

actual object NetworkHelper {

  init {
    commonRequestParams["deviceDescription"] = Browser.deviceDescription
    commonRequestParams["osVersion"] = Browser.osVersion
    commonRequestParams["timeZone"] =
      window.asDynamic().Intl.DateTimeFormat().resolvedOptions().timeZone as String
    commonRequestParams["locale"] =
      window.asDynamic().Intl.DateTimeFormat().resolvedOptions().locale as String
    commonRequestParams["campaign"] = localStorage.getItem("campaign")
    commonRequestParams["channel"] = localStorage.getItem("channel")
    commonRequestParams["appType"] = App.appType.name
  }

  actual fun isOffline() = !window.navigator.onLine

  actual fun usingCellularConnection() = false

  actual fun makePostRequest(url: String, params: Map<String, String>, callback: ((String?) -> Unit)) {
    fetch(
      url = url,
      params = params
    )
      .then { response ->
        if (response.ok) {
          response
            .text()
            .then {
              callback(it.ifBlank { null })
            }
        } else {
          callback(null)
        }
      }
  }

  fun fetch(url: String, params: Map<String, String>): Promise<Response> {
    val allParams = params.toMutableMap()
    for ((key, value) in commonRequestParams) {
      if (value != null) {
        allParams[key] = value
      }
    }
    allParams["timestamp"] = currentClockTime().millis.toString()
    allParams["languageOption"] = UserPrefs[Key.Language] ?: ""

    UserPrefs[Key.ReferredByAffiliateId]?.let {
      allParams["referredByAffiliateId"] = it
    }

    UserPrefs[Key.ReferredByUserId]?.let {
      allParams["referredByUserId"] = it
    }

    UserPrefs[Key.ReferredByPromoLinkId]?.let {
      allParams["referredByPromoLinkId"] = it
    }

    UserPrefs[Key.CorporatePlanId]?.let {
      allParams["corporatePlanId"] = it
    }

    App.cred?.let {
      allParams["cred"] = it
    }
    val paramString =
      allParams.joinToString("&") { key, value ->
        "${encodeURIComponent(key)}=${encodeURIComponent(value)}"
      }

    return window
      .fetch(
        input = url,
        init = RequestInit(
          method = "POST",
          headers = jsObj("Content-Type" to "application/x-www-form-urlencoded"),
          body = paramString,
          keepalive = true
        )
      )
  }
}
